import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import MoreVert from '@material-ui/icons/MoreVert';
import Tune from '@material-ui/icons/Tune';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const useStyles = makeStyles(theme => {
  const { palette } = theme;

  return {
    tooltip: {
      fontSize: '.8rem',
      padding: '.5rem',
      color: palette.grey.dark,
      backgroundColor: palette.white,
      display: 'flex',
      border: `1px solid ${palette.grey.medium}`,
      '& span::before': {
        border: `1px solid ${palette.grey.medium}`,
        backgroundColor: palette.white
      }
    },
    menuIcon: {
      color: palette.lightBlue.main,
      cursor: 'pointer',
      '&:hover': {
        color: palette.white
      },
      '&.active': {
        color: palette.white
      }
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '.2rem',
      userSelect: 'none',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: palette.grey.light
      },
      '& svg': {
        padding: '.2rem',
        marginRight: '.2rem'
      }
    }
  };
});

const ColumnTooltip = ({ column, onSort }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        open={open}
        onClick={toggleOpen}
        arrow
        interactive
        classes={{ tooltip: classes.tooltip }}
        title={
          <div>
            <div role="none" className={classes.menuItem} onClick={() => onSort(column, 'asc')}>
              <ArrowUpward size="small" />
              Sort by Ascending
            </div>
            <div role="none" className={classes.menuItem} onClick={() => onSort(column, 'desc')}>
              <ArrowDownward size="small" />
              Sort by Descending
            </div>
            <div
              role="none"
              className={classes.menuItem}
              onClick={() => window.console.log('Not implemented!')}
            >
              <Tune size="small" />
              Customize
            </div>
          </div>
        }
      >
        <MoreVert className={`${classes.menuIcon} ${open && 'active'}`} />
      </Tooltip>
    </ClickAwayListener>
  );
};

ColumnTooltip.propTypes = {
  column: PropTypes.shape({}).isRequired,
  onSort: PropTypes.func.isRequired
};

export default ColumnTooltip;
